/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { CreateGuestCardDTO } from "../model";
import { CreateGuestCardDTOTrackedI, CreateGuestCardDTOMeta } from "../model";
// @ts-ignore
import type { CurrentEIIResponseDTO } from "../model";
import {
  CurrentEIIResponseDTOTrackedI,
  CurrentEIIResponseDTOMeta,
} from "../model";
// @ts-ignore
import type { EIIResponseDTO } from "../model";
import { EIIResponseDTOTrackedI, EIIResponseDTOMeta } from "../model";
// @ts-ignore
import type { PersonPublicParentDTO } from "../model";
import {
  PersonPublicParentDTOTrackedI,
  PersonPublicParentDTOMeta,
} from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * MemberApi - axios parameter creator
 * @export
 */
export const MemberApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a guest card
     * @summary Creates a guest card
     * @param {boolean} [sendEmail] send an email containing a barcode of the card
     * @param {boolean} [forRental] card is for rental
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCreateGuestCardPost: (
      sendEmail?: boolean,
      forRental?: boolean,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/createGuestCard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (sendEmail !== undefined) {
        localVarQueryParameter["sendEmail"] = sendEmail;
      }

      if (forRental !== undefined) {
        localVarQueryParameter["forRental"] = forRental;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns current EII response.
     * @summary Gets EII
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberEiiGet: (options: RawAxiosRequestConfig = {}): RequestArgs => {
      const localVarPath = `/member/eii`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Submits an EII response scholarship purposes.
     * @summary EII Submit
     * @param {EIIResponseDTO} eIIResponseDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberEiiSubmitPost: (
      eIIResponseDTO: EIIResponseDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'eIIResponseDTO' is not null or undefined
      assertParamExists(
        "memberEiiSubmitPost",
        "eIIResponseDTO",
        eIIResponseDTO,
      );
      const localVarPath = `/member/eii/submit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        eIIResponseDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberInfoGet: (options: RawAxiosRequestConfig = {}): RequestArgs => {
      const localVarPath = `/member/info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {PersonPublicParentDTO} personPublicParentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberInfoPost: (
      personPublicParentDTO: PersonPublicParentDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personPublicParentDTO' is not null or undefined
      assertParamExists(
        "memberInfoPost",
        "personPublicParentDTO",
        personPublicParentDTO,
      );
      const localVarPath = `/member/info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        personPublicParentDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type memberCreateGuestCardPostParams = {
  sendEmail?: boolean;
  forRental?: boolean;
};
export type memberEiiGetParams = {};
export type memberEiiSubmitPostParams = { eIIResponseDTO: EIIResponseDTO };
export type memberInfoGetParams = {};
export type memberInfoPostParams = {
  personPublicParentDTO: PersonPublicParentDTOTrackedI;
};

export const memberCreateGuestCardPostMeta = {
  sendEmail: propertyMeta(
    "sendEmail",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  forRental: propertyMeta(
    "forRental",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
};
export const memberEiiGetMeta = {};
export const memberEiiSubmitPostMeta = {
  eIIResponseDTO: propertyMeta(
    "eIIResponseDTO",
    false,
    true,
    false,
    EIIResponseDTOMeta,
  ),
};
export const memberInfoGetMeta = {};
export const memberInfoPostMeta = {
  personPublicParentDTO: propertyMeta(
    "personPublicParentDTO",
    false,
    true,
    false,
    PersonPublicParentDTOMeta,
  ),
};

/**
 * MemberApi - functional programming interface
 * @export
 */
export const useMemberApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MemberApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Creates a guest card
     * @summary Creates a guest card
     * @param {boolean} [sendEmail] send an email containing a barcode of the card
     * @param {boolean} [forRental] card is for rental
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCreateGuestCardPostRaw(
      props: memberCreateGuestCardPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateGuestCardDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCreateGuestCardPost(
          props.sendEmail,
          props.forRental,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberCreateGuestCardPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CreateGuestCardDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CreateGuestCardDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns current EII response.
     * @summary Gets EII
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberEiiGetRaw(
      props: memberEiiGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CurrentEIIResponseDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberEiiGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberEiiGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CurrentEIIResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CurrentEIIResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Submits an EII response scholarship purposes.
     * @summary EII Submit
     * @param {EIIResponseDTO} eIIResponseDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberEiiSubmitPostRaw(
      props: memberEiiSubmitPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberEiiSubmitPost(
        props.eIIResponseDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberEiiSubmitPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberInfoGetRaw(
      props: memberInfoGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonPublicParentDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberInfoGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberInfoGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonPublicParentDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonPublicParentDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {PersonPublicParentDTO} personPublicParentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberInfoPostRaw(
      props: memberInfoPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonPublicParentDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberInfoPost(
        props.personPublicParentDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberInfoPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonPublicParentDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonPublicParentDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Creates a guest card
     * @summary Creates a guest card
     * @param {boolean} [sendEmail] send an email containing a barcode of the card
     * @param {boolean} [forRental] card is for rental
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCreateGuestCardPost(
      sendEmail?: boolean,
      forRental?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateGuestCardDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCreateGuestCardPost(
          sendEmail,
          forRental,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberCreateGuestCardPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CreateGuestCardDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CreateGuestCardDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns current EII response.
     * @summary Gets EII
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberEiiGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CurrentEIIResponseDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberEiiGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberEiiGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CurrentEIIResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CurrentEIIResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Submits an EII response scholarship purposes.
     * @summary EII Submit
     * @param {EIIResponseDTO} eIIResponseDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberEiiSubmitPost(
      eIIResponseDTO: EIIResponseDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberEiiSubmitPost(
        eIIResponseDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberEiiSubmitPost"]?.[
          localVarOperationServerIndex
        ]?.url;

      return createRequestFunction<void>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client).catch((a) => {
        notificationStore.evalErrorMessage(
          a,
          "An internal error has occured, please try again and contact us if the issue is not resolved!",
        );
        return a;
      });
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberInfoGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonPublicParentDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberInfoGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberInfoGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonPublicParentDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonPublicParentDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {PersonPublicParentDTO} personPublicParentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberInfoPost(
      personPublicParentDTO: PersonPublicParentDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonPublicParentDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberInfoPost(
        personPublicParentDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MemberApi.memberInfoPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonPublicParentDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonPublicParentDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * MemberApi - interface
 * @export
 * @interface MemberApi
 */
export interface MemberApiInterface {
  /**
   * Creates a guest card
   * @summary Creates a guest card
   * @param {boolean} [sendEmail] send an email containing a barcode of the card
   * @param {boolean} [forRental] card is for rental
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApiInterface
   */
  memberCreateGuestCardPost(
    sendEmail?: boolean,
    forRental?: boolean,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CreateGuestCardDTO>;

  /**
   * Returns current EII response.
   * @summary Gets EII
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApiInterface
   */
  memberEiiGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CurrentEIIResponseDTO>;

  /**
   * Submits an EII response scholarship purposes.
   * @summary EII Submit
   * @param {EIIResponseDTO} eIIResponseDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApiInterface
   */
  memberEiiSubmitPost(
    eIIResponseDTO: EIIResponseDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Tests Post.
   * @summary Test
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApiInterface
   */
  memberInfoGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonPublicParentDTO>;

  /**
   * Tests Post.
   * @summary Test
   * @param {PersonPublicParentDTO} personPublicParentDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberApiInterface
   */
  memberInfoPost(
    personPublicParentDTO: PersonPublicParentDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonPublicParentDTO>;
}
